import { createElement as rc, useCallback } from 'react';
import useEventSink from '../../hooks/useEventSink';
import useActiveRecord from '../../hooks/useActiveRecord';
import { Button, fromTheme, styled } from 'lib_ui-primitives';
import useFormContext from '../../hooks/useFormContext';
import { isDisabled } from './helpers';

export const DialogButton = styled(Button)`
    display: flex;
    flex-grow: 1;
    width: auto;
    min-width: 60px;
    max-width: ${fromTheme('modal', 'button', 'maxWidth')};
    justify-content: center;
`;
DialogButton.displayName = 'DialogButton';

const _p = {
    useFormContext,
    useActiveRecord
};
export const _private = _p;
export default function FormButton(props) {
    const {
        hNode,
        hNode: { formAction: _formAction, title, buttonStyle, id, subtype = '', variant, size },
        ...otherProps
    } = props;
    //UI 1.x.x required  different actions for everything.
    //UI 2.x.x is more flexible, and is most powerful when using as few as possible.
    // treat "print" as "submit":
    const formAction = _formAction === 'print' ? 'submit' : _formAction;

    const context = _p.useFormContext();
    const [, publish] = useEventSink();
    const { namespace, relation, record, type, formInstanceId } = _p.useActiveRecord();

    const onClick = useCallback(() => {
        // Include this form's formInstanceId so ActiveRecord can ignore the result if
        // another form opens while rules processing is still running.
        const payload = { record };
        // Include isDirty for cancel so willCancel rule can show confirmation
        // before the event propagates to other subscribers (e.g. MergedReadProvider)
        if (formAction === 'cancel') {
            payload.isDirty = !!context?.isDirty;
        }
        publish(
            payload,
            // use || operator here instead of ?? because subtype can be an empty string (
            // generated by blockly)
            { verb: formAction, namespace, relation, type: subtype || type, formInstanceId },
            { debugDetail: 'FormButton' }
        );
    }, [namespace, relation, record, type, formInstanceId, subtype, publish, formAction, context?.isDirty]);

    return rc(DialogButton, {
        id,
        hNode,
        value: title,
        buttonStyle,
        variant: variant || 'secondary',
        destructive: buttonStyle === 'Negative',
        size: size || 'lg',
        onClick,
        disabled: isDisabled(context, formAction),
        ...otherProps
    });
}
